<dashboard-dialog-frame [header]="header" [dialogRef]='dialogRef'>

	<div class="p-3 h-100 d-flex flex-column justify-content-between">
		<div>
			<common-text-field [field]="meetCode()"></common-text-field>

			@if(dialogContext.data?.isMeetCodeGenerated){
			<p class="mt-3">Note: The current Google Meet code has been set using the Google Meet API and already has associated Google Calendar events.</p>
			<p>IMPORTANT: This will not change the Meet code for any existing events and does not automatically adjust invitees.</p>
			}

		</div>

		<div class="mt-3">
			<common-button-row [center]="true">
				<button class="btn btn-standard" #saveBtn>Save</button>
				<button class="btn btn-standard" (click)="form.resetAll()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>